// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import useReleaseChangeLog from 'hooks/useReleaseChangeLog';
import React from 'react';
import type { UiVersionStatus } from 'utilities/uiVersion';
import ReleaseChangeLogDialog from './ReleaseChangeLogDialog';

export default function ReleaseChangeLogController({
  open,
  uiVersionStatus,
  onOpenChange,
}: Readonly<{
  open: boolean;
  uiVersionStatus?: UiVersionStatus;
  onOpenChange: (open: boolean) => void;
}>) {
  const { automatic, close, retry, version, content } = useReleaseChangeLog(uiVersionStatus, open);

  if (!open && !automatic) return null;

  return (
    <ReleaseChangeLogDialog
      automatic={automatic}
      version={version}
      onClose={() => {
        close();
        if (open) onOpenChange(false);
      }}
      onRetry={retry}
      content={content}
    />
  );
}
